import { createHelpers, getField, updateField } from 'vuex-map-fields'
import workflowApi from '../../../api/workflow/workflow'
import { BUSINESS_CODE, FORM_TEMPLATE_CODE, WORKFLOW_STATUS, LOCAL_STORAGE_KEY } from '../../../constant/constant'
// import g2eApi from '../../../api/hr/g2e'
import { getStorage } from '../../../utils/storageUtil'

import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { getArraySorter, isArrayEmptyOrNull } from '@/utils/arrayUtil'
import { WORKFLOW_META_KEY } from '@/constant/constant'
import bwWorkflowApi from '@/api/workflow/bwWorkflow'
import config from '@/config/config.js'

// const BUSINESS_CODE = {
//   TRAINING: 'training',
//   BIRTH_SUBSIDY: 'birth-subsidy',
//   MARRIAGE_SUBSIDY: 'marriage-subsidy'
// }

const eDoc = [
  { id: 1,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.SUGGEST,
    nameI18nCode: 'eDocSuggest.title',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/eDocSuggest',
    historyUrl: '/tasklist/eDocSuggestHistory',
    groupUrl: '/tasklist/eDocSugGroup',
    groupHistoryUrl: '/tasklist/eDocSugGroupHistory',
    attentionUrl: '/tasklist/attentionEDocSuggest',
    attentionHistoryUrl: '/tasklist/attentionEDocSuggestHistory'
  },
  { id: 2,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.DOC_FLOW,
    nameI18nCode: 'eDocInternal.title',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/eDocInternal',
    historyUrl: '/tasklist/eDocInternalHistory',
    groupUrl: '/tasklist/eDocIntGroup',
    groupHistoryUrl: '/tasklist/eDocIntGroupHistory',
    attentionUrl: '/tasklist/attentionEDocInt',
    attentionHistoryUrl: '/tasklist/attentionEDocIntHistory'
    // attentionUrl: '/tasklist/attentionTrainingList'
  }
]

const eSign = config.isShowESign ? [
  { id: 3,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.ESIGN,
    nameI18nCode: 'TaskList.eSign.title',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/eSignList',
    historyUrl: '/tasklist/eSignListHistory',
    groupUrl: '/tasklist/eSignGroupList',
    groupHistoryUrl: '/tasklist/eSignGroupListHistory',
    attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ESIGN,
    attentionHistoryUrl: '/tasklist/attentionESignListHistory'
  }
] : []

const attendance = config.isShowAttendance ? [
  { id: 7,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.ATTEND_CHANGE,
    nameI18nCode: 'Attendance.explanationTime',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/idGeneralList/' + BUSINESS_CODE.ATTEND_CHANGE,
    historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.ATTEND_CHANGE,
    groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.ATTEND_CHANGE,
    groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.ATTEND_CHANGE,
    attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ATTEND_CHANGE
  }
] : []

const attendanceMain = config.isShowAttendance
  ? [{
    // 出勤
    id: 2,
    subGroupNameI18nCode: 'Attendance.Title',
    groupJobNum: 0,
    attentionJobNum: 0,
    subItems: [
      ...attendance
    ]
  }] : []

const leaveMark = config.isShowMapa ? [
  {
    id: 10,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.LEAVE_MARK,
    nameI18nCode: 'eLeave.ALRegistrationData',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/idGeneralList/' + BUSINESS_CODE.LEAVE_MARK,
    historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.LEAVE_MARK,
    groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.LEAVE_MARK,
    groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.LEAVE_MARK,
    attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.LEAVE_MARK
  }
] : []

const medicalCert = [
  { id: 9,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.SICK_LEAVE,
    nameI18nCode: 'eleave.SickForm',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/mcList',
    historyUrl: '/tasklist/mcListHistory/',
    groupUrl: '/tasklist/mcGroupList',
    // groupHistoryUrl: '',
    attentionUrl: '/tasklist/attentionMcList/'
  }
]

const noLongLeave = [
  { id: 11,
    formTemplateCode: FORM_TEMPLATE_CODE.ELEAVE,
    businessCode: BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS,
    nameI18nCode: 'eLeave.noLongFerias',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/idGeneralList/' + BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS,
    historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS,
    groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS,
    groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS,
    attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ELEAVE_NO_LONG_FERIAS
  }
]

const ot = config.isShowOT ? [
  {
    id: 12,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.OT_PROPOSAL,
    nameI18nCode: 'Workflow.Form.OTProposal',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/bwGeneralList/' + BUSINESS_CODE.OT_PROPOSAL,
    historyUrl: '/tasklist/bwGeneralListHistory/' + BUSINESS_CODE.OT_PROPOSAL,
    // groupUrl: '/tasklist/bwGeneralGroupList/' + BUSINESS_CODE.OT_PROPOSAL,
    // groupHistoryUrl: '/tasklist/bwGeneralGroupListHistory/' + BUSINESS_CODE.OT_PROPOSAL,
    attentionUrl: '/tasklist/bwAttentionGeneralList/' + BUSINESS_CODE.OT_PROPOSAL,
    attentionHistoryUrl: '/tasklist/bwAttentionGeneralListHistory/' + BUSINESS_CODE.OT_PROPOSAL
  },
  {
    id: 13,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.OT_RECORD,
    nameI18nCode: 'Workflow.Form.OTRecord',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/bwGeneralList/' + BUSINESS_CODE.OT_RECORD,
    historyUrl: '/tasklist/bwGeneralListHistory/' + BUSINESS_CODE.OT_RECORD,
    // groupUrl: '/tasklist/bwGeneralGroupList/' + BUSINESS_CODE.OT_RECORD,
    // groupHistoryUrl: '/tasklist/bwGeneralGroupListHistory/' + BUSINESS_CODE.OT_RECORD,
    attentionUrl: '/tasklist/bwAttentionGeneralList/' + BUSINESS_CODE.OT_RECORD,
    attentionHistoryUrl: '/tasklist/bwAttentionGeneralListHistory/' + BUSINESS_CODE.OT_RECORD
  }
  /*,
  {
    id: 14,
    formTemplateCode: null,
    businessCode: BUSINESS_CODE.OT_COMPENSATE,
    nameI18nCode: 'Workflow.Form.OTCompensate',
    jobNum: 0,
    groupJobNum: 0,
    attentionJobNum: 0,
    url: '/tasklist/bwGeneralList/' + BUSINESS_CODE.OT_COMPENSATE,
    historyUrl: '/tasklist/bwGeneralListHistory/' + BUSINESS_CODE.OT_COMPENSATE,
    groupUrl: '/tasklist/bwGeneralGroupList/' + BUSINESS_CODE.OT_COMPENSATE,
    groupHistoryUrl: '/tasklist/bwGeneralGroupListHistory/' + BUSINESS_CODE.OT_COMPENSATE,
    attentionUrl: '/tasklist/bwAttentionGeneralList/' + BUSINESS_CODE.OT_COMPENSATE
  } */
] : []

const otMain = config.isShowOT
  ? [{
    // 超時工作
    id: 4,
    subGroupNameI18nCode: 'Attendance.OTTitle',
    groupJobNum: 0,
    attentionJobNum: 0,
    subItems: [
      ...ot
    ]
  }] : []

// initial state
const state = {
  // defaultNextStaffCode: null,
  item: {},
  staffsAttentionMe: [],
  myAttentionStaffs: [],
  items: [
    {
      // 公文
      id: 0,
      subGroupNameI18nCode: 'TaskList.title.oficio',
      groupJobNum: 0,
      attentionJobNum: 0,
      subItems: [
        { id: 0,
          formTemplateCode: null,
          businessCode: BUSINESS_CODE.OFICIO,
          nameI18nCode: 'TaskList.Outbox',
          jobNum: 0,
          groupJobNum: 0,
          attentionJobNum: 0,
          url: '/tasklist/outboxList',
          historyUrl: '/tasklist/outboxListHistory',
          groupUrl: '/tasklist/outboxGroupList',
          groupHistoryUrl: '/tasklist/outboxGroupListHistory',
          attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.OFICIO,
          attentionHistoryUrl: '/tasklist/attentionOutboxListHistory'
          // attentionUrl: '/tasklist/attentionTrainingList'
        },
        ...eDoc,
        ...eSign
      ]
    },
    {
      // 年假/缺勤
      id: 1,
      subGroupNameI18nCode: 'Main.Absence',
      groupJobNum: 0,
      attentionJobNum: 0,
      subItems: [
        { id: 4,
          formTemplateCode: FORM_TEMPLATE_CODE.ELEAVE,
          businessCode: BUSINESS_CODE.ELEAVE_FERIAS,
          // chinName: '批准享受年假',
          // portName: 'A justificacao de ferias',
          nameI18nCode: 'eLeave.ApproveAL',
          // attentionChinName: '批准享受年假 *',
          // attentionPortName: 'A justificacao de ferias *',
          jobNum: 0,
          groupJobNum: 0,
          attentionJobNum: 0,
          url: '/tasklist/idGeneralList/' + BUSINESS_CODE.ELEAVE_FERIAS,
          historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.ELEAVE_FERIAS,
          groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.ELEAVE_FERIAS,
          groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.ELEAVE_FERIAS,
          attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ELEAVE_FERIAS
        },
        { id: 5,
          formTemplateCode: FORM_TEMPLATE_CODE.ELEAVE,
          businessCode: BUSINESS_CODE.ELEAVE_FALTA,
          // chinName: '批准合理缺勤',
          // portName: 'A justificação de falta(s)',
          nameI18nCode: 'eLeave.ApproveAbsence',
          // attentionChinName: '批准合理缺勤 *',
          // attentionPortName: 'A justificação de falta(s) *',
          jobNum: 0,
          groupJobNum: 0,
          attentionJobNum: 0,
          url: '/tasklist/idGeneralList/' + BUSINESS_CODE.ELEAVE_FALTA,
          historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.ELEAVE_FALTA,
          groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.ELEAVE_FALTA,
          groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.ELEAVE_FALTA,
          attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ELEAVE_FALTA
        },
        { id: 6,
          formTemplateCode: FORM_TEMPLATE_CODE.ELEAVE,
          businessCode: BUSINESS_CODE.ELEAVE_TRANSFER,
          // chinName: '轉移年假',
          // portName: 'A transferencia de ferias',
          nameI18nCode: 'eLeave.TransferAL',
          // attentionChinName: '轉移年假 *',
          // attentionPortName: 'A transferencia de ferias *',
          jobNum: 0,
          groupJobNum: 0,
          attentionJobNum: 0,
          url: '/tasklist/idGeneralList/' + BUSINESS_CODE.ELEAVE_TRANSFER,
          historyUrl: '/tasklist/idGeneralListHistory/' + BUSINESS_CODE.ELEAVE_TRANSFER,
          groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.ELEAVE_TRANSFER,
          groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.ELEAVE_TRANSFER,
          attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.ELEAVE_TRANSFER
        },
        ...medicalCert,
        ...leaveMark,
        ...noLongLeave
      ]
    },
    // {
    //   // 出勤
    //   id: 2,
    //   subGroupNameI18nCode: 'Attendance.Title',
    //   groupJobNum: 0,
    //   attentionJobNum: 0,
    //   subItems: [
    //     ...attendance
    //   ]
    // },
    ...attendanceMain,

    {
      // 培訓
      id: 3,
      subGroupNameI18nCode: 'Main.Training',
      groupJobNum: 0,
      attentionJobNum: 0,
      subItems: [
        { id: 7,
          formTemplateCode: FORM_TEMPLATE_CODE.TRAINING,
          businessCode: BUSINESS_CODE.TRAINING,
          // chinName: '培訓報名',
          // portName: 'training',
          nameI18nCode: 'Training.TrainingApply',
          // attentionChinName: '培訓報名 *',
          // attentionPortName: 'training *',
          jobNum: 0,
          groupJobNum: 0,
          attentionJobNum: 0,
          url: '/tasklist/trainingList',
          historyUrl: '/tasklist/trainingHistory',
          groupUrl: '/tasklist/generalGroupList/' + BUSINESS_CODE.TRAINING,
          groupHistoryUrl: '/tasklist/generalGroupListHistory/' + BUSINESS_CODE.TRAINING,
          attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.TRAINING
          // attentionUrl: '/tasklist/attentionTrainingList'
        }
      ]
    },
    ...otMain
    // {
    //   id: 4,
    //   subGroupNameI18nCode: 'OTHER',
    //   jobNum: 0,
    //   groupJobNum: 0,
    //   attentionJobNum: 0,
    //   subItems: []
    // }
    // { id: 5,
    //   formTemplateCode: FORM_TEMPLATE_CODE.BIRTH_SUBSIDY,
    //   businessCode: BUSINESS_CODE.BIRTH_SUBSIDY,
    //   chinName: '出生津貼',
    //   portName: 'birth-subsidy',
    //   attentionChinName: '出生津貼 *',
    //   attentionPortName: 'birth-subsidy *',
    //   jobNum: 0,
    //   attentionJobNum: 0,
    //   url: '/tasklist/generalList/' + BUSINESS_CODE.BIRTH_SUBSIDY,
    //   attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.BIRTH_SUBSIDY
    // },
    // { id: 6,
    //   formTemplateCode: FORM_TEMPLATE_CODE.MARRIAGE_SUBSIDY,
    //   businessCode: BUSINESS_CODE.MARRIAGE_SUBSIDY,
    //   chinName: '結婚津貼',
    //   portName: 'marriage-subsidy',
    //   attentionChinName: '結婚津貼 *',
    //   attentionPortName: 'marriage-subsidy *',
    //   jobNum: 0,
    //   attentionJobNum: 0,
    //   url: '/tasklist/generalList/' + BUSINESS_CODE.MARRIAGE_SUBSIDY,
    //   attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.MARRIAGE_SUBSIDY
    // }
    // { id: 7,
    //   formTemplateCode: null,
    //   businessCode: BUSINESS_CODE.SICK_LEAVE,
    //   // chinName: '培訓報名',
    //   // portName: 'training',
    //   nameI18nCode: 'TaskList.SickLeave.AwareList',
    //   // attentionChinName: '培訓報名 *',
    //   // attentionPortName: 'training *',
    //   jobNum: 0,
    //   groupJobNum: 0,
    //   attentionJobNum: 0,
    //   url: '/tasklist/awareList/' + BUSINESS_CODE.SICK_LEAVE,
    //   historyUrl: '/tasklist/awareListHistory',
    //   // groupUrl: '',
    //   // groupHistoryUrl: '',
    //   attentionUrl: '/tasklist/attentionGeneralList/' + BUSINESS_CODE.SICK_LEAVE
    //   // attentionUrl: '/tasklist/attentionTrainingList'
    // }
  ],
  activeWorkItems: [
    {
      activityDefinitionId: null,
      assignedToEntityId: null,
      assignedToEuid: null,
      businessCode: null,
      changedTo: null,
      chinContent: null,
      completedBy: null,
      completedTime: null,
      defaultNextEntityId: null,
      defaultNextEuid: null,
      formAttribute: {
        applicant: null,
        appliedDate: null,
        approvalDate: null,
        businessCode: null,
        chinTaskListDesc1: null,
        chinTaskListDesc2: null,
        chinTaskListTitle: null,
        entityId: null,
        formIdentity: null,
        id: null,
        portTaskListDesc1: null,
        portTaskListDesc2: null,
        portTaskListTitle: null,
        statusCode: null,
        subunitId: null
      },
      formAttributeId: null,
      formMetaList: [
        {
          formAttributeId: null,
          formMetaKey: null,
          formMetaValue: null,
          id: null,
          workItemId: null
        }
      ],
      formParameterList: {
        additionalProp1: null,
        additionalProp2: null,
        additionalProp3: null
      },
      id: null,
      initiatedBy: null,
      initiatedTime: null,
      isAddedToSigningCart: false,
      message: null,
      portContent: null,
      processId: null,
      status: null,
      signatureFieldName: null,
      // Below are add for display
      // isShowAttachment: false,
      show: false,
      newMessage: null, // the message for next staff
      pdfInitParams: {
        url: null,
        httpHeaders: { Authorization: null },
        withCredentials: true,
        CMapReaderFactory
      },
      isFinalStep: false,
      opinion: null // agree & submit / approval message
    }
  ],
  groupWorkItems: [
    {
      activityDefinitionId: null,
      assignedToEntityId: null,
      assignedToEuid: null,
      businessCode: null,
      changedTo: null,
      chinContent: null,
      completedBy: null,
      completedTime: null,
      defaultNextEntityId: null,
      defaultNextEuid: null,
      formAttribute: {
        applicant: null,
        appliedDate: null,
        approvalDate: null,
        businessCode: null,
        chinTaskListDesc1: null,
        chinTaskListDesc2: null,
        chinTaskListTitle: null,
        entityId: null,
        formIdentity: null,
        id: null,
        portTaskListDesc1: null,
        portTaskListDesc2: null,
        portTaskListTitle: null,
        statusCode: null,
        subunitId: null
      },
      formAttributeId: null,
      formMetaList: [
        {
          formAttributeId: null,
          formMetaKey: null,
          formMetaValue: null,
          id: null,
          workItemId: null
        }
      ],
      formParameterList: {
        additionalProp1: null,
        additionalProp2: null,
        additionalProp3: null
      },
      id: null,
      initiatedBy: null,
      initiatedTime: null,
      isAddedToSigningCart: false,
      message: null,
      portContent: null,
      processId: null,
      status: null,
      signatureFieldName: null,
      // Below are add for display
      // isShowAttachment: false,
      show: false,
      newMessage: null, // the message for next staff
      pdfInitParams: {
        url: null,
        httpHeaders: { Authorization: null },
        withCredentials: true,
        CMapReaderFactory
      },
      isFinalStep: false,
      opinion: null // agree & submit / approval message
    }
  ],
  attentionActiveWorkItems: [
    {
      activityDefinitionId: null,
      applicantChinName: null,
      applicantPortName: null,
      assignedToEntityId: null,
      assignedToEuid: null,
      businessCode: null,
      changedTo: null,
      chinContent: null,
      completedBy: null,
      completedTime: null,
      defaultNextEntityId: null,
      defaultNextEuid: null,
      formAttribute: {
        applicant: null,
        appliedDate: null,
        approvalDate: null,
        businessCode: null,
        chinTaskListDesc1: null,
        chinTaskListDesc2: null,
        chinTaskListTitle: null,
        entityId: null,
        formIdentity: null,
        id: null,
        portTaskListDesc1: null,
        portTaskListDesc2: null,
        portTaskListTitle: null,
        statusCode: null,
        subunitId: null
      },
      formAttributeId: null,
      formMetaList: [
        {
          formAttributeId: null,
          formMetaKey: null,
          formMetaValue: null,
          id: null,
          workItemId: null
        }
      ],
      formParameterList: {
        additionalProp1: null,
        additionalProp2: null,
        additionalProp3: null
      },
      id: null,
      initiatedBy: null,
      initiatedTime: null,
      isAddedToSigningCart: false,
      message: null,
      portContent: null,
      processId: null,
      status: null,
      signatureFieldName: null,
      // Below are add for display
      // isShowAttachment: false,
      show: false,
      newMessage: null
      // applicantChinName: null,
      // applicantPortName: null // the message for next staff
    }
  ],
  historyWorkItems: [],
  groupHistoryWorkItems: [],
  attentionHistoryWorkItems: [],
  allActiveWorkItemCounts: {},
  bwItemCounts: {},
  progressOption: {
    showEndTask: false,
    businessCodes: [],
    backLink: null
  }
}

// getters
const getters = {
  getField,
  getBwSignCount: (state) => {
    return state.bwItemCounts.signing_cart_counts
  },
  countPersonalTotalJobNumber: (state) => {
    let totalNum = 0
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (subItem.jobNum) {
          totalNum += parseInt(subItem.jobNum)
        }
      })
    })
    return totalNum
  },
  countGroupTotalJobNumber: (state) => {
    let totalNum = 0
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (subItem.groupJobNum) {
          totalNum += parseInt(subItem.groupJobNum)
        }
      })
    })
    return totalNum
  },
  countAttentionTotalJobNumber: (state) => {
    let totalNum = 0
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (subItem.attentionJobNum) {
          totalNum += parseInt(subItem.attentionJobNum)
        }
      })
    })
    return totalNum
  },
  countPersonalTotalSubItemJobNumbers: (state) => {
    let subItemTotalNums = []
    state.items.forEach(item => {
      let totalNum = 0
      item.subItems.forEach(subItem => {
        if (subItem.jobNum) {
          totalNum += parseInt(subItem.jobNum)
        }
      })
      subItemTotalNums[item.id] = totalNum
    })
    return subItemTotalNums
  },
  countGroupTotalSubItemJobNumbers: (state) => {
    let subItemTotalNums = []
    state.items.forEach(item => {
      let totalNum = 0
      item.subItems.forEach(subItem => {
        if (subItem.groupJobNum) {
          totalNum += parseInt(subItem.groupJobNum)
        }
      })
      subItemTotalNums[item.id] = totalNum
    })
    return subItemTotalNums
  },
  countAttentionTotalSubItemJobNumbers: (state) => {
    let subItemTotalNums = []
    state.items.forEach(item => {
      let totalNum = 0
      item.subItems.forEach(subItem => {
        if (subItem.attentionJobNum) {
          totalNum += parseInt(subItem.attentionJobNum)
        }
      })
      subItemTotalNums[item.id] = totalNum
    })
    return subItemTotalNums
  }

}

// actions
const actions = {

  // countItemByBusinessCode ({ commit }, businessCode) {
  //   let item = state.items.find(item => item.businessCode === businessCode)
  //   // let setMethodName = 'set' + item.code + 'JobNum'

  //   workflowApi.countPerActWorkItemByBusinessCode(number => {
  //     commit('setItemJobNumByIndex', { 'index': item.id, 'jobNum': number })
  //   }, businessCode)
  // },

  // countGroupItemByBusinessCode ({ commit }, businessCode) {
  //   let item = state.items.find(item => item.businessCode === businessCode)
  //   // let setMethodName = 'set' + item.code + 'JobNum'

  //   workflowApi.countGroupsActiveWorkItemsByBusiness(resp => {
  //     commit('setItemGroupJobNumByIndex', { 'index': item.id, 'resp': resp })
  //   }, businessCode)
  // },

  // countAttentionItemByBusinessCode ({ commit }, businessCode) {
  //   let item = state.items.find(item => item.businessCode === businessCode)
  //   // let setMethodName = 'set' + item.code + 'JobNum'

  //   workflowApi.getFollowingStaffsByBusinessCode(staffs => {
  //     commit('setItemAttentionJobNumByIndex', { item, staffs })
  //   }, businessCode)
  // },

  // original code
  countBwItems ({ commit }) {
    if (config.isShowOT) {
      return new Promise((resolve, reject) => {
        bwWorkflowApi.getAllCounts(resp => {
          if (resp.status === 201 || resp.status === 200) {
            commit('setBwItemCounts', resp.data.data)
          }
          resolve()
        })
      })
    } else {
      return new Promise((resolve) => { resolve() })
    }
  },

  // temp code used until the boardware api's bug is fixed
  // countBwItems ({ commit }) {
  //   if (config.isShowOT) {
  //     return new Promise((resolve, reject) => {
  //       bwWorkflowApi.getAllCounts(resp => {
  //         if (resp.status === 201 || resp.status === 200) {
  //           let data = resp.data.data
  //           bwWorkflowApi.getFollowingStaffsByBusinessCode(resp => {
  //             let cnt = 0
  //             resp.data.data.forEach(follower => {
  //               cnt = cnt + parseInt(follower.tasksCount)
  //             })
  //             if (parseInt(data.following_staff_counts['ot-proposal']) !== cnt) {
  //               data.following_staff_counts['ot-proposal'] = 0
  //               data.following_staff_counts['ot-record'] = 0
  //             }
  //             commit('setBwItemCounts', data)
  //             resolve()
  //           }, 'ot-proposal')
  //         }
  //       })
  //     })
  //   } else {
  //     return new Promise((resolve) => { resolve() })
  //   }
  // },

  countPersonalItems ({ commit }) {
    return new Promise((resolve, reject) => {
      workflowApi.countPerActWorkItems(items => {
        let mergeItem = { ...items, ...state.bwItemCounts.personal_active_counts }
        commit('setPersonalItemsJobNum', mergeItem)
        resolve()
      })
    })
  },

  countGroupItems ({ commit }) {
    return new Promise((resolve, reject) => {
      workflowApi.countGroupsActiveWorkItems(items => {
        commit('setGroupItemsJobNum', items)
        resolve()
      })
    })
  },

  countAttentionItems ({ commit }) {
    return new Promise((resolve, reject) => {
      workflowApi.countFollowingStaffTasks(items => {
        let mergeItem = { ...items, ...state.bwItemCounts.following_staff_counts }
        commit('setAttentionItemsJobNum', mergeItem)
        resolve()
      })
    })
  },

  getAllActiveWorkItemCounts ({ commit }) {
    workflowApi.getAllPerActiveWorkItemCounts(cb => {
      commit('setAllActiveWorkItemCounts', cb)
    })
  },

  getItemByBusinessCode ({ commit, state }, businessCode) {
    let i = null
    for (const item of state.items) {
      i = item.subItems.find(subItem => subItem.businessCode === businessCode)
      if (i) break
    }
    commit('setItem', i)
  },

  // getAttentionItemByBusinessCode ({ commit, state }, businessCode) {
  //   const i = state.attentionItems.find(item => item.businessCode === businessCode)
  //   commit('setItem', i)
  // },

  getActiveItems ({ commit }, businessCode) {
    let downloadUrl = workflowApi.getPdfFromDmsUrl
    if (businessCode === 'atdSupplementary') {
      downloadUrl = workflowApi.downloadPdfFromOssUrl
    }
    return new Promise((resolve, reject) => {
      workflowApi.getActiveItemsByBusinessCode(activeWorkItems => {
        let tempItems = activeWorkItems.map(item => {
          return Object.assign(item, { status: false,
            // isShowAttachment: false,
            newMessage: null,
            opinion: this._vm.$chPtObjData('defaultCommentChinDesc', item),
            show: false,
            pdfInitParams: {
              // url: workflowApi.getPdfFromDmsUrl + item.id + '/' + item.formAttribute.formCode,
              url: downloadUrl + item.id + '/' + item.formAttribute.formCode,
              httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
              withCredentials: true,
              CMapReaderFactory
            }
          })
        })
        commit('setActiveWorkItems', tempItems)
        resolve()
      }, businessCode, [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX])
    })
  },

  getGroupItems ({ commit }, { businessCode, groupId }) {
    return new Promise((resolve, reject) => {
      workflowApi.groupActiveWorkItems(workItems => {
        let tempItems = workItems.map(item => {
          return Object.assign(item, { status: false,
            newMessage: null,
            opinion: this._vm.$chPtObjData('defaultCommentChinDesc', item),
            show: false,
            pdfInitParams: {
              url: workflowApi.downloadPdfFromOssUrl + item.id + '/' + item.formAttribute.formCode,
              httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
              withCredentials: true,
              CMapReaderFactory
            }
          })
        })
        commit('setGroupWorkItems', tempItems)
        resolve()
      }, businessCode, groupId, [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX])
    })
  },

  getGroupHistoryItems ({ commit }, { businessCode, groupId }) {
    return new Promise((resolve, reject) => {
      workflowApi.groupHistoryWorkItems(items => {
        let tempItems = items.map(item => {
          return Object.assign(item, {
          // status: false,
          // isShowAttachment: false,
          // newMessage: null,
          // show: false,
            pdfInitParams: {
              url: workflowApi.downloadPdfFromOssUrl + item.id + '/' + item.formAttribute.formCode,
              httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
              withCredentials: true,
              CMapReaderFactory
            }
          })
        })
        commit('setGroupHistoryWorkItems', tempItems)
        resolve()
      }, businessCode, groupId, [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX])
    })
  },

  getAttentionHistoryItems ({ commit }, { businessCode, attentionStaffEuid }) {
    return new Promise((resolve, reject) => {
      workflowApi.getFollowingStaffHistoryTasks(items => {
        commit('setAttentionHistoryWorkItems', items)
        resolve()
      }, businessCode, attentionStaffEuid)
    })
  },

  getHistoryItems ({ commit }, businessCode) {
    let downloadUrl = workflowApi.getPdfFromDmsUrl
    if (businessCode === 'atdSupplementary') {
      downloadUrl = workflowApi.downloadPdfFromOssUrl
    }
    return new Promise((resolve, reject) => {
      workflowApi.getHistoryItemsByBusinessCode(items => {
        let tempItems = items.map(item => {
          return Object.assign(item, {
          // status: false,
          // isShowAttachment: false,
          // newMessage: null,
          // show: false,
            pdfInitParams: {
              // url: workflowApi.getPdfFromDmsUrl + item.id + '/' + item.formAttribute.formCode,
              url: downloadUrl + item.id + '/' + item.formAttribute.formCode,
              httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
              withCredentials: true,
              CMapReaderFactory
            }
          })
        })
        commit('setHistoryWorkItems', tempItems)
        resolve()
      }, businessCode, [WORKFLOW_META_KEY.IS_URGENT, WORKFLOW_META_KEY.IS_DIRECT_SEND_TO_EDOCX])
    })
  },

  getAttentionActiveItems ({ commit, state }, payload) {
    let downloadUrl = workflowApi.getPdfFromDmsUrl
    if (payload.businessCode === 'atdSupplementary') {
      downloadUrl = workflowApi.downloadPdfFromOssUrl
    }
    return new Promise((resolve, reject) => {
      workflowApi.getFollowingStaffTasks(activeWorkItems => {
        let tempItems = activeWorkItems.map(item => {
          return Object.assign(item, { status: false,
          // isShowAttachment: false,
            newMessage: null,
            show: false,
            pdfInitParams: {
              // url: workflowApi.getPdfFromDmsUrl + item.id + '/' + item.formAttribute.formCode,
              url: downloadUrl + item.id + '/' + item.formAttribute.formCode,
              httpHeaders: { Authorization: 'Bearer ' + getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN) },
              withCredentials: true,
              CMapReaderFactory
            }
          })
        })
        commit('setAttentionActiveWorkItems', tempItems)
        resolve()
      }, payload.businessCode, payload.euid)

    // let tempItems2 = tempItems.map(item => {
    //   g2eApi.searchStaff(cb => {
    //     return Object.assign(item, {
    //       applicantChinName: cb.chinName,
    //       applicantPortName: cb.portName
    //     })
    //   }, item.initiatedBy)
    // })
    // commit('setAttentionActiveWorkItems', tempItems2)
    })
  },

  getMyAttentionStaffs ({ commit }, businessCode) {
    return new Promise((resolve, reject) => {
      workflowApi.getFollowingStaffsByBusinessCode(staffs => {
        commit('setMyAttentionStaffs', staffs)
        resolve()
      }, businessCode)
    })
  },

  getMyAttentionStaffsBw ({ commit }, businessCode) {
    return new Promise((resolve, reject) => {
      workflowApi.getFollowingStaffsByBusinessCode(staffs => {
        // 因為兩邊排序唔同, 所以 call 完又 call
        bwWorkflowApi.getFollowingStaffsByBusinessCode(resp => {
          staffs.forEach(staff => {
            resp.data.data.every(element => {
              if (staff.euid === element.euid) {
                staff.tasksCount = element.tasksCount
                return false
              } else {
                return true
              }
            })
          })
          commit('setMyAttentionStaffs', staffs)
          resolve()
        }, businessCode)
      }, businessCode)
    })
  },

  getMyFollowingStaffs ({ commit }) {
    return new Promise((resolve, reject) => {
      workflowApi.getFollowingStaffs(staffs => {
        commit('setMyAttentionStaffs', staffs)
        resolve()
      })
    })
  },

  // get staff following the staffCode passed in
  getStaffsAttentionMe ({ commit }, staffCode) {
    return new Promise((resolve, reject) => {
      workflowApi.getStaffFollowers(staffs => {
        commit('setStaffsAttentionMe', staffs)
        resolve()
      }, staffCode)
    })
  }

  //   getDefaultNextStaffCode ({ commit }, applicantStaffCode) {
  //     taskListApi.getDefaultNextStaffCode(staffCode => {
  //       commit('setDefaultNextStaffCode', staffCode)
  //     }, applicantStaffCode)
  //   }

}

// mutations
const mutations = {
  updateField,

  setProgressOption (state, progressOption) {
    state.progressOption = progressOption
  },

  setItemJobNumByIndex (state, payload) {
    // console.log('setItemJobNumByIndex')
    // console.log(payload)
    state.items[payload.index].jobNum = payload.jobNum
  },

  setItemGroupJobNumByIndex (state, payload) {
    let total = 0
    for (var propt in payload.resp) {
      total = total + payload.resp[propt]
    }
    state.items[payload.index].groupJobNum = total
  },

  setItemAttentionJobNumByIndex (state, payload) {
    let total = 0
    payload.staffs.forEach(staff => {
      total += staff.tasksCount
    })
    state.items[payload.item.id].attentionJobNum = total
  },

  setPersonalItemsJobNum (state, payload) {
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (payload[subItem.businessCode]) {
          subItem.jobNum = payload[subItem.businessCode]
        } else {
          subItem.jobNum = 0
        }
      })
    })
  },

  setGroupItemsJobNum (state, payload) {
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (payload[subItem.businessCode]) {
          subItem.groupJobNum = payload[subItem.businessCode]
        } else {
          subItem.groupJobNum = 0
        }
      })
    })
  },

  setAttentionItemsJobNum (state, payload) {
    state.items.forEach(item => {
      item.subItems.forEach(subItem => {
        if (payload[subItem.businessCode]) {
          subItem.attentionJobNum = payload[subItem.businessCode]
        } else {
          subItem.attentionJobNum = 0
        }
      })
    })
  },

  setItem (state, item) {
    state.item = item
  },

  setActiveWorkItems (state, activeWorkItems) {
    state.activeWorkItems = activeWorkItems
    state.activeWorkItems.forEach(
      element => {
        element.isNewApplicant = true
      }
    )
  },

  setGroupWorkItems (state, workItems) {
    state.groupWorkItems = workItems
    state.groupWorkItems.forEach(
      element => {
        element.isNewApplicant = true
      }
    )
  },

  setGroupHistoryWorkItems (state, items) {
    let tempItems = items.map(item => {
      // if (item.status === WORKFLOW_STATUS.HISTORY) { // if status is transfer 'T' , the formMetaList is null
      if (item.status !== WORKFLOW_STATUS.ACTIVE) {
        let actionMetas = item.formMetaList.filter(meta => meta.formMetaKey === 'action')
        actionMetas.sort(getArraySorter('id', false))
        let actionTypeId = null
        if (!isArrayEmptyOrNull(actionMetas)) {
          actionTypeId = parseInt(actionMetas[0].formMetaValue)
        }
        return Object.assign(item, {
          actionTypeId: actionTypeId
        })
      } else {
        return item
      }
    })
    // tempItems.sort((a, b) => b.completedTime - a.completedTime)
    state.groupHistoryWorkItems = tempItems
  },

  setAttentionHistoryWorkItems (state, items) {
    let tempItems = items.map(item => {
      // if (item.status === WORKFLOW_STATUS.HISTORY) { // if status is transfer 'T' , the formMetaList is null
      if (item.status !== WORKFLOW_STATUS.ACTIVE) {
        let actionMetas = item.formMetaList.filter(meta => meta.formMetaKey === 'action')
        actionMetas.sort(getArraySorter('id', false))
        let actionTypeId = null
        if (!isArrayEmptyOrNull(actionMetas)) {
          actionTypeId = parseInt(actionMetas[0].formMetaValue)
        }
        return Object.assign(item, {
          actionTypeId: actionTypeId
        })
      } else {
        return item
      }
    })
    // tempItems.sort((a, b) => b.completedTime - a.completedTime)
    state.attentionHistoryWorkItems = tempItems
  },

  setHistoryWorkItems (state, items) {
    let tempItems = items.map(item => {
      // if (item.status === WORKFLOW_STATUS.HISTORY) { // if status is transfer 'T' , the formMetaList is null
      if (item.status !== WORKFLOW_STATUS.ACTIVE) {
        let actionMetas = item.formMetaList.filter(meta => meta.formMetaKey === 'action')
        actionMetas.sort(getArraySorter('id', false))
        let actionTypeId = null
        if (!isArrayEmptyOrNull(actionMetas)) {
          actionTypeId = parseInt(actionMetas[0].formMetaValue)
        }
        return Object.assign(item, {
          actionTypeId: actionTypeId
        })
      } else {
        return item
      }
    })
    // tempItems.sort((a, b) => b.completedTime - a.completedTime)
    state.historyWorkItems = tempItems
  },

  setAttentionActiveWorkItems (state, activeWorkItems) {
    // activeWorkItems.reverse()
    state.attentionActiveWorkItems = activeWorkItems
  },

  setMyAttentionStaffs (state, staffs) {
    state.myAttentionStaffs = staffs
  },

  setStaffsAttentionMe (state, staffs) {
    state.staffsAttentionMe = staffs
  },

  setAllActiveWorkItemCounts (state, counts) {
    state.allActiveWorkItemCounts = counts
  },

  setBwItemCounts (state, counts) {
    state.bwItemCounts = counts
  }

  // setTotalNumber (state) {
  //   state.totalNumber = 0
  //   state.items.forEach(item => {
  //     state.totalNumber += item.jobNum
  //   })
  // }

  //   setDefaultNextStaffCode (state, staffCode) {
  //     state.defaultNextStaffCode = staffCode
  //   }

}

export const { mapMultiRowFields: mapWorkflowMultiRowFields } = createHelpers({
  getterType: 'workflow/getField',
  mutationType: 'workflow/updateField'
})

export const workflow = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
